import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      borderColor: '#b0bec5',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    fileFormatCard: {
      width: '100%',
      height: 200,
      backgroundColor: theme.palette.grey[300],
      borderBottom: '1px solid #b0bec5',
      '& div': {
        color: theme.palette.grey[600],
      },
    },
    content: {
      paddingBottom: `${theme.spacing(2)} !important`,
    },
    date: {
      paddingTop: theme.spacing(1),
      direction: 'rtl !important',
      textAlign: 'left',
    },
    buttonGroup: {
      marginBlockStart: theme.spacing(1),
      marginInlineStart: theme.spacing(-1),
      marginBottom: '-10px',
    },
    deleteButton: {
      marginInlineStart: theme.spacing(1),
    },
    viewButton: {
      marginInlineStart: 0,
    },
    fileName: {
      cursor: 'pointer',
    },
  };
});

export const useStylesDocsList = makeStyles((theme) => {
  return {
    root: {
      borderColor: '#b0bec5',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    fileFormatCard: {
      width: '100%',
      height: 200,
      backgroundColor: theme.palette.grey[300],
      borderBottom: '1px solid #b0bec5',
      '& div': {
        color: theme.palette.grey[600],
      },
    },
    content: {
      paddingBottom: `${theme.spacing(2)} !important`,
    },
    date: {
      paddingTop: theme.spacing(1),
      direction: 'rtl !important',
      textAlign: 'left',
    },
    buttonGroup: {
      marginBlockStart: theme.spacing(1),
      marginInlineStart: theme.spacing(-1),
      marginBottom: '-10px',
    },
    deleteButton: {
      marginInlineStart: theme.spacing(1),
    },
    viewButton: {
      marginInlineStart: 0,
    },
    fileName: {
      cursor: 'pointer',
    },
  };
});
